import type { CSSProperties } from 'react';
import '../components/atomic/layout/app_screen/app_screen.css';
import { containFitScale } from '../../../infrastructure/runtime';
import { useAppFit } from '../../hooks/useAppFit';
import { GoHomeButton } from '../components/atomic/buttons/go_home_button/GoHomeButton';
import { RestartButton } from '../components/atomic/buttons/restart_button/RestartButton';
import { ScreenHeader } from '../components/atomic/layout/screen_header/ScreenHeader';
import { SkyAtmosphere } from '../components/composite/atmosphere/sky_atmosphere/SkyAtmosphere';
import type { ScreenViewProps } from '../shared/screenViewProps';
import { HeaderText } from './header_text/HeaderText';
import { ResultStatsContent } from './result_stats_content/ResultStatsContent';
import type { DeliveryResultScreenController } from './DeliveryResultScreenController';
import type { DeliveryResultScreenModel } from './DeliveryResultScreenModelScreen';
import './delivery_result_screen.css';

export type DeliveryResultScreenViewProps = ScreenViewProps<
  DeliveryResultScreenModel,
  DeliveryResultScreenController
>;

/** Delivery result screen. */
export function DeliveryResultScreenView({
  model,
  controller,
}: DeliveryResultScreenViewProps) {
  const fit = useAppFit();
  const contain = containFitScale(fit.scale);

  return (
    <div className="app-screen delivery-result-screen">
      <SkyAtmosphere
        variant="delivery"
        sunBeamsClassName="delivery-result-screen__sun-beams"
      />
      <div
        className="delivery-result-plaques"
        style={
          {
            '--fit-contain-inv-x': String(contain.invX),
            '--fit-contain-inv-y': String(contain.invY),
            '--fit-contain-uniform': String(contain.uniform),
          } as CSSProperties
        }
      >
        <ScreenHeader showSubHeader={false} />
        <HeaderText />
        <ResultStatsContent rating={model.rating} />
        {model.showRestart ? (
          <RestartButton
            onClick={controller.handleRestart}
            disabled={!model.canRestart}
          />
        ) : null}
        <GoHomeButton onClick={controller.handleGoHome} />
      </div>
    </div>
  );
}
